import { render, staticRenderFns } from "./listModal.vue?vue&type=template&id=6f788cfe"
import script from "./listModal.vue?vue&type=script&lang=js"
export * from "./listModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports